import { Typography, WithStyles } from "@material-ui/core";
import { styles } from "./LogoutView.styles";
import * as React from "react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { CenteredContainer } from "../components/CenteredContainer/CenteredContainer";
import { BlueButton } from "../components/Buttons/BlueButton";
import { withStyles } from "@material-ui/core/styles";
import { getLogoutReason } from "../../constants/LOGOUT";
import { LOGOUT_REASON } from "../../auth/authClient/src/constants";

interface ILogoutViewProps extends WithStyles<typeof styles> {}

const LogoutViewPure: React.FunctionComponent<ILogoutViewProps> = ({ classes }) => {
    const history = useHistory();
    const [logoutText] = useState<string>(getLogoutReason(localStorage.getItem(LOGOUT_REASON)));

    useEffect(() => {
        localStorage.removeItem(LOGOUT_REASON);
    }, []);

    return (
        <CenteredContainer>
            <div className={classes.loggedOut}>
                <Typography variant="h5" gutterBottom>
                    {logoutText}
                </Typography>
                <BlueButton onClick={() => history.push("/")}>Return to home</BlueButton>
            </div>
        </CenteredContainer>
    );
};

export const LogoutView = withStyles(styles)(LogoutViewPure);
